import { customElement, property } from 'lit/decorators.js'
import { html, LitElement } from 'lit'
import style from './style/zaptic-external-link-style'

/**
 * Renders link with 'opens in new window' icon.
 *
 * Figma component: https://www.figma.com/file/BpMdzCsfZAXmpHQCowcsWD/Global-Design-Library-(Master-%40-7f17203)?type=design&node-id=225-8463&mode=design&t=cO9re950aN2vzEhT-0
 *
 * Storybook: ExternalLink.stories.tsx
 */
@customElement('zaptic-external-link')
export class ExternalLink extends LitElement {
    static styles = style

    @property()
    href?: string

    @property()
    target?: '_self' | '_parent' | '_top' | '_blank'

    render() {
        const href = this.href || '#'
        const target = this.target || '_self'
        return html`
            <a href=${href} target=${target} class="external-link">
                <slot></slot>
                <zaptic-icon icon-name="external-link" class="external-link-icon"></zaptic-icon>
            </a>
        `
    }
}
